import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { RichmediaAdsService } from 'src/app/core/services/richmedia-ads.service';
import { RichmediaItem, RootRichmedia } from 'src/app/models/richmedia-ads';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-home-richmedia-ads',
  templateUrl: './home-richmedia-ads.component.html',
  styleUrls: ['./home-richmedia-ads.component.css']
})
export class HomeRichmediaAdsComponent {
  richmediaList: RichmediaItem[] = [];
  rootData!: RootRichmedia;

  constructor(private richmediaService: RichmediaAdsService, private router: Router) { }

  ngOnInit(): void {
    this.loadRichmedia();
  }

  loadRichmedia(): void {
    this.richmediaService.getRichmediaRoot()
      .then(root => {
        this.rootData = root;               // guardamos el root completo
        this.richmediaList = root.richmedia; // solo usamos el array
        //window.location.reload();
        console.log('Richmedia cargado:', this.richmediaList);
      })
      .catch(error => {
        console.error('Error al cargar richmedia:', error);
      });
  }

  isActive(richmedia: RichmediaItem): boolean {
    const now = new Date();
    const start = new Date(richmedia.start);
    const end = new Date(richmedia.end);

    return now >= start && now <= end;
  }

  editRichmedia(index: number): void {
    this.router.navigate(['/form-richmedia', index]);
  }

  deleteRichmedia(index: number, item: RichmediaItem): void {
    Swal.fire({
      title: '¿Eliminar campaña?',
      text: `La campaña "${item.name}" será eliminada.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        // Eliminamos localmente
        this.richmediaList.splice(index, 1);

        // Construimos el objeto para backend
        const updatedData = {
          breakingNews: null, // si tu JSON original trae esto
          richmedia: this.richmediaList
        };

        this.richmediaService.saveRichmedia(updatedData).subscribe({
          next: () => {
            Swal.fire('Eliminada', 'La campaña ha sido eliminada.', 'success');
          },
          error: (err) => {
            console.error('Error al eliminar', err);
            Swal.fire('Error', 'No se pudo eliminar la campaña.', 'error');
            // Restaurar si falla
            this.loadRichmedia();
          }
        });
      }
    });

  }

}
